// extracted by mini-css-extract-plugin
export default {"documentation":"Documentation_documentation__ddhgd","confluenceTh":"Documentation_confluenceTh__ssTMY"};